// src/pages/Profile.js

// src/pages/Profile.js

import React from 'react';
import '../styles/Profile.css';

const Profile = () => {
  return (
    <div className="profile-container">
      <h1>Your Profile</h1>
      <p>Username: JohnDoe123</p>
      <p>Email: john.doe@example.com</p>
      <p>Subscription: Premium</p>
    </div>
  );
};

export default Profile;





// import React from 'react';
// import '../styles/Profile.css';  // Import the CSS

// const Profile = () => {
//   return (
//     <div className="profile-container">
//       <h1>User Profile</h1>
//       <p>This page will show the user's profile information.</p>
//     </div>
//   );
// };

// export default Profile;




// // src/pages/Profile.js
// import React from 'react';

// const Profile = () => {
//   return <div>Profile Page</div>;
// };

// export default Profile;
